import { createIcon, Icon } from '@chakra-ui/icons'

const IntegrityChecked = props => (
    <Icon width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
        <path
            d="M15.9994 26.6144C15.9994 26.6144 22.0292 23.4137 24 20.0001C25.9708 16.5866 26.0926 9.13248 26.0926 9.13248L15.9994 5.38636L5.90625 9.13248C5.90625 9.13248 6.02918 16.5866 8 20.0001C9.97082 23.4137 15.9994 26.6144 15.9994 26.6144Z"
            fill="white"
            stroke="#333333"
            strokeWidth="3"
        />
        <path
            d="M12 14.8445L14.8605 17.4593L20.3247 12.4645"
            stroke="#4FAF54"
            strokeWidth="2"
        />
    </Icon>
)

const DrawerInactive = props => (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
        <rect
            x="6.33333"
            y="9.00008"
            width="19.3333"
            height="2.66667"
            fill="#FEF5F5"
            stroke="#333333"
            strokeWidth="0.666667"
        />
        <rect
            x="6.33333"
            y="15.0001"
            width="19.3333"
            height="2.66667"
            fill="#FEF5F5"
            stroke="#333333"
            strokeWidth="0.666667"
        />
        <rect
            x="6.33333"
            y="20.3333"
            width="19.3333"
            height="2.66667"
            fill="#FEF5F5"
            stroke="#333333"
            strokeWidth="0.666667"
        />
        <path
            d="M7.35156 7.69389V5.3335"
            stroke="#EF3837"
            strokeWidth="0.666667"
        />
        <path
            d="M4.70823 9.04324L2.66406 7.86304"
            stroke="#EF3837"
            strokeWidth="0.666667"
        />
        <path
            d="M5.82864 7.92185L4.64844 5.87769"
            stroke="#EF3837"
            strokeWidth="0.666667"
        />
    </Icon>
)

const DrawerActive = props => (
    <Icon viewBox="0 0 32 32" fill="none" {...props}>
        <rect
            x="7.80734"
            y="21.7515"
            width="20.6667"
            height="2.66667"
            transform="rotate(-45 7.80734 21.7515)"
            fill="#FEF5F5"
            stroke="#333333"
            strokeWidth="0.666667"
        />
        <rect
            x="9.69141"
            y="7.13791"
            width="20.6667"
            height="2.66667"
            transform="rotate(45 9.69141 7.13791)"
            fill="#FEF5F5"
            stroke="#333333"
            strokeWidth="0.666667"
        />
        <path
            d="M16.0533 17.2758L14.1639 15.3885L16.0544 13.5125L17.9408 15.3893L16.0533 17.2758Z"
            fill="#EF3837"
            stroke="#333333"
            strokeWidth="0.666667"
        />
    </Icon>
)

const GChat = createIcon({
    displayName: 'GChat',
    viewBox: '0 0 32 32',
    path: (
        <path
            d="M18.5 14.5h3m-11 0h3m1 0h3M6 7v18l3-3h16.5V7H6Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
        />
    ),
})

const GMail = createIcon({
    displayName: 'GMail',
    viewBox: '0 0 32 32',
    path: (
        <path
            d="M5 9.73684V8H27V9.73684M5 9.73684V24.7895H27V9.73684M5 9.73684L16 16.6842L27 9.73684"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
        />
    ),
})

const Profile = createIcon({
    displayName: 'Profile',
    viewBox: '0 0 32 32',
    path: [
        <path
            key={1}
            d="M21 10C21 7.23858 18.7614 5 16 5C13.2386 5 11 7.23858 11 10C11 12.7614 13.2386 15 16 15C18.7614 15 21 12.7614 21 10Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
        />,
        <path
            key={2}
            d="M26 27H6V23.5C6 21.2909 7.79086 19.5 10 19.5H22C24.2091 19.5 26 21.2909 26 23.5V27Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
        />,
    ],
})

const LogOut = createIcon({
    displayName: 'Log Out',
    viewBox: '0 0 32 32',
    path: [
        <path
            d="M21.5217 10.5215L27 15.9998L21.5217 21.4781"
            fill="none"
            key={1}
            stroke="currentColor"
            strokeWidth="3"
        />,
        <path
            d="M20.9783 7.5V4H6.5V27.5H20.9783V24M27 16C21.5327 16 13 16 13 16"
            fill="none"
            key={2}
            stroke="currentColor"
            strokeWidth="3"
        />,
    ],
})

const LogOut24 = createIcon({
    displayName: 'Log Out',
    viewBox: '0 0 24 24',
    path: [
        <path
            d="M14.9837 5.625V3H4.12502V20.625H14.9837V18M19.5 12H9"
            fill="none"
            key={1}
            stroke="currentColor"
            strokeWidth="3"
        />,
        <path
            d="M15.3913 7.8913L19.5 12L15.3913 16.1087"
            fill="none"
            key={2}
            stroke="currentColor"
            strokeWidth="3"
        />,
    ],
})

const Livebooks = createIcon({
    displayName: 'Livebooks',
    viewBox: '0 0 32 32',
    path: (
        <path
            d="M9.5 10.5H17.5M26 9V13M26 14V18M26 19V23M5 5V26.5H22V5H5Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
        />
    ),
})

const Search = createIcon({
    displayName: 'Search',
    viewBox: '0 0 24 24',
    path: (
        <path
            d="M14.2943 14.3286C15.2915 13.3402 15.9091 11.9695 15.9091 10.4545C15.9091 7.44208 13.467 5 10.4545 5C7.44208 5 5 7.44208 5 10.4545C5 13.467 7.44208 15.9091 10.4545 15.9091C11.9521 15.9091 13.3086 15.3056 14.2943 14.3286ZM14.2943 14.3286L19.5 19.5"
            fill="none"
            stroke="#333333"
            strokeWidth="2"
        />
    ),
})

const SearchBold = props => (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M14.2943 14.3286C15.2915 13.3402 15.9091 11.9695 15.9091 10.4545C15.9091 7.44208 13.467 5 10.4545 5C7.44208 5 5 7.44208 5 10.4545C5 13.467 7.44208 15.9091 10.4545 15.9091C11.9521 15.9091 13.3086 15.3056 14.2943 14.3286ZM14.2943 14.3286L19.5 19.5"
            stroke="#454545"
            strokeWidth="3"
        />
    </Icon>
)

const Modules = createIcon({
    displayName: 'Modules',
    viewBox: '0 0 24 24',
    path: (
        <path
            d="M2 12.0769V19H22V12.0769M5.75 13.2308H18.25M5.75 8.61538H18.25M5.75 4H18.25"
            fill="none"
            stroke="#63517C"
            strokeWidth="3"
        />
    ),
})

const LearningUnits = createIcon({
    displayName: 'LearningUnits',
    viewBox: '0 0 24 24',
    path: (
        <path
            d="M11.8793 8.39647L15.9246 10.8699V15.5918M11.8793 8.39647L8.07725 11.0947L8.07606 15.5918L11.8782 17.6154L15.9246 15.5918M11.8793 8.39647L11.8795 5.69823M15.9246 15.5918L17.7166 17.4998M11.8795 5.69823L9.77051 4.79882V3M11.8795 5.69823L13.9946 4.79882V3M8.07992 15.5918L6.28772 17.4996M6.28772 17.4996L7.1816 19.7232L5.98686 20.9952M6.28772 17.4996L4.19474 16.5433L3 17.8153M17.7166 17.4998L19.8053 16.5481L21 17.8201M17.7166 17.4998L16.8184 19.728L18.0131 21"
            fill="none"
            stroke="#63517C"
            strokeWidth="3"
        />
    ),
})

const Credits = createIcon({
    displayName: 'Credits',
    viewBox: '0 0 24 24',
    path: [
        <path
            d="M21 10.1053L17.6512 6H13.8837H10.5349H6.76744L3 10.1053L10.1163 19H11.3721H13.0465H13.8837L21 10.1053Z"
            fill="none"
            key={1}
            stroke="#63517C"
            strokeWidth="3"
        />,
        <path
            d="M21 9.10526H15.5581M3 9.10526H8.86047M10.5349 5L8.86047 9.10526M8.86047 9.10526L11.3721 18M8.86047 9.10526H15.5581M13.8837 5L15.5581 9.10526M15.5581 9.10526L13.0465 18"
            fill="none"
            key={2}
            stroke="#63517C"
        />,
    ],
})

const Duration = createIcon({
    displayName: 'Duration',
    viewBox: '0 0 24 24',
    path: (
        <path
            d="M11 6L12 7L13 6M7 3H17V7.63353L13 11.3404L17 15.0472V19.6807H7V15.0472L11 11.3404L7 7.63353V3Z"
            fill="none"
            stroke="#63517C"
            strokeWidth="3"
        />
    ),
})

const CaretDown = createIcon({
    displayName: 'CaretDown',
    viewBox: '0 0 24 24',
    path: (
        <path d="M3 6L9 12L15 6" fill="none" stroke="#6E5A8A" strokeWidth="3" />
    ),
})

const CaretUp = createIcon({
    displayName: 'CaretUp',
    viewBox: '0 0 24 24',
    path: (
        <path
            d="M15 12L9 6L3 12"
            fill="none"
            stroke="#6E5A8A"
            strokeWidth="3"
        />
    ),
})

const CaretLeft = createIcon({
    displayName: 'CaretLeft',
    viewBox: '0 0 16 16',
    path: (
        <path
            d="M11 14.25L5 8L11 1.75"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
        />
    ),
})

const CaretRight = createIcon({
    displayName: 'CaretRight',
    viewBox: '0 0 16 16',
    path: (
        <path
            d="M5 14.25L11 8L5 1.75"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
        />
    ),
})

const ArrowForward = createIcon({
    displayName: 'ArrowForward',
    viewBox: '0 0 32 33',
    path: [
        <path
            d="M27 16.5H4"
            fill="none"
            key={1}
            stroke="currentColor"
            strokeWidth="3"
        />,
        <path
            d="M18 7.5L27 16.5L18 25.5"
            fill="none"
            key={2}
            stroke="currentColor"
            strokeWidth="3"
        />,
    ],
})

const Triangle = props => (
    <Icon viewBox="0 0 18 18" fill="none" {...props}>
        <path d="M9 4L14 13H4L9 4Z" stroke="#454545" strokeWidth="3" />
    </Icon>
)

const Cross = createIcon({
    displayName: 'Cross',
    viewBox: '0 0 24 24',
    path: (
        <path
            d="M5 5L19.5 19.5M19.5 5L5 19.5"
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
        />
    ),
})

const CrossLight = props => (
    <Icon height={6} width={6} viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M5 5L19.5 19.5M19.5 5L5 19.5"
            stroke="#5C5C5C"
            strokeWidth="3"
        />
    </Icon>
)

const PreviousArrow = createIcon({
    displayName: 'PreviousArrow',
    viewBox: '0 0 24 24',
    path: [
        <path
            d="M4 12H20"
            key={1}
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
        />,
        <path
            d="M10 6L4 12L10 18"
            key={2}
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
        />,
    ],
})

const NextArrow = createIcon({
    displayName: 'NextArrow',
    viewBox: '0 0 24 24',
    path: [
        <path
            d="M20 12H4"
            key={1}
            stroke="#6E5A8A"
            strokeWidth="3"
            fill="none"
        />,
        <path
            d="M14 6L20 12L14 18"
            key={2}
            stroke="#6E5A8A"
            strokeWidth="3"
            fill="none"
        />,
    ],
})

const Target = createIcon({
    displayName: 'Target',
    viewBox: '0 0 24 24',
    path: [
        <path
            d="M15 12C15 12.7441 15 15 15 15C15 15 12.9128 15 12 15C11.1608 15 9 15 9 15C9 15 9 12.8176 9 12C9 11.1608 9 9 9 9C9 9 11.1824 9 12 9C12.8505 9 15 9 15 9C15 9 15 11.1936 15 12Z"
            fill="#333333"
            key={1}
        />,
        <path
            d="M12 5.25V3.9V3M18.75 12H21M12 18.75V21M3 12H5.25M19.2 12C19.2 10.0382 19.2 4.8 19.2 4.8C19.2 4.8 14.0147 4.8 12 4.8C10.1456 4.8 4.8 4.8 4.8 4.8C4.8 4.8 4.8 9.87796 4.8 12C4.8 14.122 4.8 19.2 4.8 19.2C4.8 19.2 10.1456 19.2 12 19.2C14.0147 19.2 19.2 19.2 19.2 19.2C19.2 19.2 19.2 13.9618 19.2 12Z"
            stroke="#333333"
            strokeWidth="3"
            strokeLinecap="square"
            fill="none"
            key={2}
        />,
    ],
})

const QnA = createIcon({
    displayName: 'QnA',
    viewBox: '0 0 24 24',
    path: [
        <path
            d="M3 19.1104V6H21V16.8522H6.68182L3 19.1104Z"
            stroke="#333333"
            strokeWidth="3"
            fill="none"
            key={1}
        />,
        <path
            d="M9.01657 13.7472C8.95166 13.7472 8.90202 13.73 8.86766 13.6957C8.83329 13.6651 8.80657 13.6384 8.78747 13.6155L8.60993 13.3864C8.48393 13.417 8.34457 13.4322 8.19184 13.4322C7.82911 13.4322 7.5122 13.375 7.24111 13.2604C6.97002 13.1459 6.75811 12.974 6.60538 12.745C6.45266 12.512 6.36866 12.2238 6.35338 11.8801C6.34957 11.7198 6.34766 11.5556 6.34766 11.3876C6.34766 11.2158 6.34957 11.0459 6.35338 10.8779C6.36866 10.538 6.45266 10.2517 6.60538 10.0188C6.75811 9.78587 6.97002 9.61023 7.24111 9.49187C7.5122 9.36968 7.82911 9.30859 8.19184 9.30859C8.55075 9.30859 8.86575 9.36968 9.13684 9.49187C9.40793 9.61023 9.62175 9.78587 9.77829 10.0188C9.93484 10.2517 10.0188 10.538 10.0303 10.8779C10.0379 11.0459 10.0417 11.2158 10.0417 11.3876C10.0417 11.5556 10.0379 11.7198 10.0303 11.8801C10.0074 12.3307 9.86802 12.6858 9.6122 12.9454L10.0532 13.5697C10.057 13.5735 10.0608 13.5811 10.0647 13.5926C10.0685 13.604 10.0704 13.6136 10.0704 13.6212C10.0742 13.6556 10.0627 13.6842 10.036 13.7071C10.0131 13.7339 9.98638 13.7472 9.95584 13.7472H9.01657ZM8.19184 12.4586C8.35602 12.4586 8.48775 12.4109 8.58702 12.3154C8.69011 12.2161 8.74357 12.0596 8.74738 11.8458C8.75502 11.6816 8.75884 11.5231 8.75884 11.3704C8.75884 11.2139 8.75502 11.0554 8.74738 10.895C8.74357 10.7538 8.71684 10.6373 8.6672 10.5457C8.62138 10.454 8.55647 10.3872 8.47247 10.3452C8.39229 10.3032 8.29875 10.2822 8.19184 10.2822C8.08493 10.2822 7.98947 10.3032 7.90547 10.3452C7.82529 10.3872 7.76038 10.454 7.71075 10.5457C7.66111 10.6373 7.63438 10.7538 7.63057 10.895C7.62675 11.0554 7.62484 11.2139 7.62484 11.3704C7.62484 11.5231 7.62675 11.6816 7.63057 11.8458C7.6382 12.0596 7.69166 12.2161 7.79093 12.3154C7.89402 12.4109 8.02766 12.4586 8.19184 12.4586Z"
            fill="#333333"
            key={2}
        />,
        <path
            d="M11.4955 13.3193C11.3188 13.3193 11.165 13.2931 11.0341 13.2407C10.9032 13.1883 10.8017 13.1109 10.7297 13.0083C10.6599 12.9058 10.625 12.7825 10.625 12.6385C10.625 12.5469 10.6414 12.464 10.6741 12.3898C10.709 12.3156 10.7592 12.248 10.8246 12.1869C10.8901 12.1258 10.9686 12.0691 11.0603 12.0167C10.9839 11.9338 10.9283 11.8553 10.8934 11.7811C10.8606 11.7047 10.8443 11.6294 10.8443 11.5553C10.8443 11.4505 10.8715 11.3534 10.9261 11.264C10.9806 11.1745 11.0635 11.1025 11.1748 11.048C11.2883 10.9913 11.4301 10.9629 11.6003 10.9629C11.7574 10.9629 11.8883 10.9902 11.993 11.0447C12.0977 11.0993 12.1774 11.1713 12.2319 11.2607C12.2865 11.348 12.3137 11.4418 12.3137 11.5422C12.3137 11.6273 12.2963 11.7047 12.2614 11.7745C12.2265 11.8422 12.1763 11.9043 12.1108 11.9611C12.0454 12.0178 11.9679 12.0734 11.8785 12.128L12.1926 12.4487C12.2014 12.4356 12.2221 12.4029 12.2548 12.3505C12.2897 12.2982 12.3246 12.224 12.3595 12.128C12.3661 12.1018 12.3879 12.0887 12.425 12.0887H12.8374C12.857 12.0887 12.8723 12.0942 12.8832 12.1051C12.8941 12.116 12.8995 12.1313 12.8995 12.1509C12.8995 12.188 12.8875 12.2349 12.8635 12.2916C12.8395 12.3462 12.809 12.4051 12.7719 12.4683C12.7348 12.5294 12.6955 12.5883 12.6541 12.6451C12.6126 12.7018 12.5745 12.7509 12.5395 12.7923L12.9159 13.1818C12.929 13.1971 12.9355 13.2134 12.9355 13.2309C12.9355 13.2462 12.9301 13.2593 12.9192 13.2702C12.9083 13.2811 12.8941 13.2865 12.8766 13.2865H12.3203C12.2985 13.2865 12.281 13.2833 12.2679 13.2767C12.257 13.268 12.2461 13.2603 12.2352 13.2538L12.1206 13.1458C12.029 13.2113 11.9319 13.2571 11.8294 13.2833C11.729 13.3073 11.6177 13.3193 11.4955 13.3193ZM11.4955 12.8382C11.5501 12.8382 11.5992 12.8327 11.6428 12.8218C11.6886 12.8087 11.729 12.7869 11.7639 12.7563L11.4006 12.3931C11.357 12.4149 11.3199 12.4443 11.2894 12.4814C11.2588 12.5185 11.2435 12.5611 11.2435 12.6091C11.2435 12.6549 11.2555 12.6953 11.2795 12.7302C11.3057 12.7651 11.3374 12.7923 11.3745 12.812C11.4137 12.8294 11.4541 12.8382 11.4955 12.8382ZM11.5545 11.7811C11.5959 11.7614 11.6319 11.7418 11.6625 11.7222C11.6952 11.7003 11.7203 11.6763 11.7377 11.6502C11.7552 11.624 11.7639 11.5956 11.7639 11.5651C11.7639 11.5171 11.7486 11.4789 11.7181 11.4505C11.6875 11.4222 11.6472 11.408 11.597 11.408C11.5555 11.408 11.5174 11.4222 11.4825 11.4505C11.4497 11.4789 11.4334 11.5171 11.4334 11.5651C11.4334 11.5869 11.4366 11.6087 11.4432 11.6305C11.4519 11.6523 11.4661 11.6763 11.4857 11.7025C11.5054 11.7265 11.5283 11.7527 11.5545 11.7811Z"
            fill="#333333"
            key={3}
        />,
        <path
            d="M13.5127 13.7474C13.4784 13.7474 13.4478 13.7359 13.4211 13.713C13.3982 13.6863 13.3867 13.6557 13.3867 13.6214C13.3867 13.6061 13.3905 13.5927 13.3982 13.5813L14.704 9.91583C14.7154 9.87383 14.7403 9.83374 14.7784 9.79555C14.8204 9.75737 14.8758 9.73828 14.9445 9.73828H15.9926C16.0652 9.73828 16.1205 9.75737 16.1587 9.79555C16.1969 9.83374 16.2217 9.87383 16.2332 9.91583L17.5447 13.5813C17.5485 13.5927 17.5504 13.6061 17.5504 13.6214C17.5504 13.6557 17.5371 13.6863 17.5104 13.713C17.4874 13.7359 17.4588 13.7474 17.4244 13.7474H16.5424C16.4775 13.7474 16.4298 13.7321 16.3993 13.7016C16.3687 13.671 16.3477 13.6424 16.3363 13.6156L16.1587 13.1346H14.7784L14.6009 13.6156C14.5894 13.6424 14.5684 13.671 14.5379 13.7016C14.5112 13.7321 14.4634 13.7474 14.3947 13.7474H13.5127ZM15.0419 12.1666H15.8953L15.4657 10.878L15.0419 12.1666Z"
            fill="#333333"
            key={4}
        />,
    ],
})

const Info = createIcon({
    displayName: 'Info',
    viewBox: '0 0 24 24',
    path: [
        <path
            d="M3.5 3.5H20.5V20.5H3.5V3.5Z"
            stroke="#333333"
            strokeWidth="3"
            fill="none"
            key={1}
        />,
        <path
            d="M3.5 20.5V3.5H20.5V20.5H3.5Z"
            stroke="#333333"
            fill="none"
            strokeWidth="3"
            key={2}
        />,
        <path
            d="M12 16.5V11M12 10V7.5"
            stroke="#333333"
            fill="none"
            strokeWidth="3"
            key={3}
        />,
    ],
})

const Feedback = createIcon({
    displayName: 'Feedback',
    viewBox: '0 0 32 32',
    path: [
        <path
            d="M25.25 21.9113V6.75H5.25V21.9113H9.69444L9.43867 25.599L14.4563 21.9113H25.25Z"
            stroke="currentColor"
            strokeWidth="3"
            fill={'none'}
            key={1}
        />,
        <path
            d="M15.6641 12.7949H18.6641V15.7912H17.4879H15.6665L15.6641 12.7949Z"
            fill="currentColor"
            key={2}
        />,
        <path
            d="M16.9498 17.2946L18.6641 15.7912H17.4879L16.9498 17.2946Z"
            fill="currentColor"
            key={3}
        />,
        <path
            d="M11.8281 12.7793H14.8281V15.7756H13.652H11.8306L11.8281 12.7793Z"
            fill="currentColor"
            key={4}
        />,
        <path
            d="M13.1138 17.2789L14.8281 15.7756H13.652L13.1138 17.2789Z"
            fill="currentColor"
            key={5}
        />,
    ],
})

const Tick = createIcon({
    displayName: 'Tick',
    viewBox: '0 0 33 32',
    path: (
        <path
            d="M5 14.8268L12.5 22.3268L26.8268 8"
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
        />
    ),
})

const Tick2 = createIcon({
    displayName: 'Tick',
    viewBox: '0 0 24 24',
    path: (
        <path
            d="M3 11.7181L9.18506 18L21 6"
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
        />
    ),
})

const EnterArrow = createIcon({
    displayName: 'EnterArrow',
    viewBox: '0 0 16 16',
    path: [
        <path
            d="M6 7.91064L2.89844 10.6622L5.89844 13.1276"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="square"
            key={1}
            fill={'none'}
        />,
        <path
            d="M12.9407 2.91406V5.37947V7.49268V8.70623V10.5277H10.6645H4.07031"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="square"
            key={2}
            fill={'none'}
        />,
    ],
})
const Zap = props => (
    <Icon viewBox="0 0 16 16" {...props}>
        <mask id="path-1-inside-1_159800_125612" fill="white">
            <path d="M8.8608 2.02813L5.0061 9.14294C4.98747 9.17732 5.01375 9.21821 5.05445 9.21821H7.43253C7.46465 9.21821 7.48978 9.24453 7.48664 9.27489L7.00445 13.9432C6.99856 14.0002 7.08023 14.0226 7.1072 13.9713L10.9942 6.58618C11.0123 6.55185 10.986 6.51144 10.9456 6.51144H8.63039C8.59858 6.51144 8.57355 6.48561 8.5762 6.45549L8.96337 2.05605C8.96829 1.99973 8.88805 1.97787 8.8608 2.02813Z" />
        </mask>
        <path
            d="M5.0061 9.14294L7.64368 10.5723L7.64385 10.572L5.0061 9.14294ZM7.48664 9.27489L10.4708 9.58313L10.4708 9.58303L7.48664 9.27489ZM7.00445 13.9432L4.02033 13.6349L4.02032 13.635L7.00445 13.9432ZM7.1072 13.9713L4.45245 12.5741L4.45223 12.5745L7.1072 13.9713ZM10.9942 6.58618L8.3395 5.18883L8.33945 5.18892L10.9942 6.58618ZM8.5762 6.45549L11.5646 6.71851L11.5646 6.71849L8.5762 6.45549ZM8.96337 2.05605L11.9518 2.31904L11.952 2.31711L8.96337 2.05605ZM6.22306 0.59904L2.36836 7.71385L7.64385 10.572L11.4985 3.45722L6.22306 0.59904ZM2.36853 7.71353C1.14138 9.97789 3.00834 12.2182 5.05445 12.2182V6.21821C7.01916 6.21821 8.83356 8.37675 7.64368 10.5723L2.36853 7.71353ZM5.05445 12.2182H7.43253V6.21821H5.05445V12.2182ZM7.43253 12.2182C5.85716 12.2182 4.3058 10.8718 4.50251 8.96675L10.4708 9.58303C10.6738 7.61731 9.07213 6.21821 7.43253 6.21821V12.2182ZM4.50252 8.96666L4.02033 13.6349L9.98858 14.2514L10.4708 9.58313L4.50252 8.96666ZM4.02032 13.635C3.83496 15.43 5.13262 16.585 6.25107 16.8913C7.35693 17.1942 8.9689 16.8759 9.76216 15.3682L4.45223 12.5745C5.21853 11.118 6.77618 10.8142 7.83594 11.1044C8.90828 11.3981 10.1681 12.5133 9.98858 14.2513L4.02032 13.635ZM9.76194 15.3686L13.6489 7.98345L8.33945 5.18892L4.45245 12.5741L9.76194 15.3686ZM13.6489 7.98354C14.8385 5.72358 12.9808 3.51144 10.9456 3.51144V9.51144C8.99122 9.51144 7.18606 7.38013 8.3395 5.18883L13.6489 7.98354ZM10.9456 3.51144H8.63039V9.51144H10.9456V3.51144ZM8.63039 3.51144C10.1916 3.51144 11.7307 4.83202 11.5646 6.71851L5.58775 6.19248C5.41642 8.1392 7.00551 9.51144 8.63039 9.51144V3.51144ZM11.5646 6.71849L11.9518 2.31904L5.97492 1.79305L5.58775 6.19249L11.5646 6.71849ZM11.952 2.31711C12.1069 0.544173 10.8241 -0.589739 9.71237 -0.892476C8.61224 -1.19205 7.02365 -0.877814 6.2234 0.598415L11.4982 3.45785C10.7252 4.88382 9.19036 5.18385 8.13593 4.89672C7.06988 4.60643 5.8248 3.51161 5.97475 1.79499L11.952 2.31711Z"
            fill="white"
            mask="url(#path-1-inside-1_159800_125612)"
        />
    </Icon>
)

const Tools = createIcon({
    displayName: 'Tools',
    viewBox: '0 0 33 33',
    path: [
        <rect
            x="7"
            y="7.30664"
            width="3"
            height="3"
            key={0}
            stroke={'currentColor'}
            fill={'currentColor'}
        />,
        <rect
            x="23"
            y="7.30664"
            width="3"
            height="3"
            key={1}
            stroke={'currentColor'}
            fill={'currentColor'}
        />,
        <rect
            x="15"
            y="7.30664"
            width="3"
            height="3"
            key={2}
            stroke={'currentColor'}
            fill={'currentColor'}
        />,
        <rect
            x="7"
            y="15.3066"
            width="3"
            height="3"
            key={3}
            stroke={'currentColor'}
            fill={'currentColor'}
        />,
        <rect
            x="23"
            y="15.3066"
            width="3"
            height="3"
            key={4}
            stroke={'currentColor'}
            fill={'currentColor'}
        />,
        <rect
            x="15"
            y="15.3066"
            width="3"
            height="3"
            key={5}
            stroke={'currentColor'}
            fill={'currentColor'}
        />,
        <rect
            x="7"
            y="23.3066"
            width="3"
            height="3"
            key={6}
            stroke={'currentColor'}
            fill={'currentColor'}
        />,
        <rect
            x="23"
            y="23.3066"
            width="3"
            height="3"
            key={7}
            stroke={'currentColor'}
            fill={'currentColor'}
        />,
        <rect
            x="15"
            y="23.3066"
            width="3"
            height="3"
            key={8}
            stroke={'currentColor'}
            fill={'currentColor'}
        />,
    ],
})

const Playground = createIcon({
    displayName: 'Playground',
    viewBox: '0 0 32 32',
    path: [
        <path
            d="M10.5 21L4 14.5L10.5 8"
            stroke="#333333"
            strokeWidth="3"
            key={0}
            fill={'none'}
        />,
        <path
            d="M17.8857 4.7401L14.2397 23.706"
            stroke="#333333"
            strokeWidth="3"
            key={1}
            fill={'none'}
        />,
        <path
            d="M21.5 8L28 14.5L21.5 21"
            stroke="#333333"
            strokeWidth="3"
            key={2}
            fill={'none'}
        />,
    ],
})

const Assets = createIcon({
    displayName: 'Assets',
    viewBox: '0 0 32 33',
    path: (
        <path
            d="M26 27.5001L22.5 15.5572H7.52778M26 27.5001H8.5L5 15.5572H7.52778M26 27.5001V11.3667H16.6667V9.27148H9.08333V11.3667H7.52778V15.5572"
            stroke="#333333"
            fill="none"
            strokeWidth="3"
        />
    ),
})

const BackToTopIcon = props => {
    return (
        <Icon viewBox="0 0 36 36" {...props}>
            <g fill="none">
                <rect
                    x="1.5"
                    y="1.5"
                    width="33"
                    height="33"
                    fill="#7C6A96"
                    stroke="currentColor"
                    strokeWidth="3"
                />
                <path
                    d="M27 22L18 13L9 22"
                    stroke="white"
                    strokeWidth="3"
                    fill="none"
                />
            </g>
        </Icon>
    )
}

const MaDTick = props => {
    return (
        <Icon viewBox="0 0 22 17" {...props}>
            <g fill="none">
                <path
                    d="M2 7.71809L8.18506 14L20 2"
                    stroke="currentColor"
                    strokeWidth="3"
                />
            </g>
        </Icon>
    )
}

const MaDTickSquare = props => {
    return (
        <Icon viewBox="0 0 16 16" {...props}>
            <path
                d="M2 7.81206L6.12337 12L14 4"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
            />
        </Icon>
    )
}

const Home = props => {
    return (
        <Icon viewBox="0 0 32 32" {...props}>
            <path
                d="M3 17.5L6.5 14M29 17.5L25.5 14M6.5 14L16 4.5L25.5 14M6.5 14V27.5H13V17.5H19V27.5H25.5V14"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
            />
        </Icon>
    )
}

const Idea = props => {
    return (
        <Icon viewBox="0 0 32 32" {...props}>
            <path
                d="M13 29H19M16 4.45582V3M23.5 7.36745L25 5.91164M8.5 7.36745L7 5.91164M24.3437 20.8565L25.8437 22.3123M7.63277 20.8565L6.13277 22.3123M5.5 13.1907H4M28 13.1907H26.5M16 8.09536C17.523 8.09446 19.0015 8.59344 20.1953 9.51121C21.3891 10.429 22.2281 11.7116 22.5758 13.1507C22.9236 14.5897 22.7597 16.1007 22.1108 17.4379C21.4619 18.7751 20.3661 19.86 19.0015 20.5164L19 21.9256C19 22.6978 19.0015 24.8373 19.0015 24.8373C19.0015 24.8373 16.7956 24.8373 16 24.8373C15.2044 24.8373 13 24.8373 13 24.8373C13 24.8373 13 22.6978 13 21.9256V20.5164C11.6355 19.8601 10.5398 18.7753 9.8909 17.4382C9.24197 16.1011 9.07796 14.5904 9.42551 13.1514C9.77306 11.7124 10.6117 10.4298 11.8053 9.51189C12.9989 8.594 14.4772 8.09479 16 8.09536Z"
                stroke="#F0B847"
                strokeWidth="3"
                strokeLinecap="square"
                fill="none"
            />
        </Icon>
    )
}

const Warning = props => {
    return (
        <Icon viewBox="0 0 32 32" {...props}>
            <g fill="none">
                <path
                    d="M4.5 4.5H27.5V27.5H4.5V4.5Z"
                    stroke="#F0B847"
                    strokeWidth="3"
                />
                <path
                    d="M16 9V18.9794M16 19.9846V23"
                    stroke="#F0B847"
                    strokeWidth="3"
                />
            </g>
        </Icon>
    )
}

const Caution = props => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M21 20L12 4L3 20H21Z"
                stroke="currentColor"
                strokeWidth="2"
            />
            <path
                d="M12 17V13M12 12V10.5"
                stroke="currentColor"
                strokeWidth="2"
            />
        </Icon>
    )
}

const Star = props => {
    return (
        <Icon viewBox="0 0 22 22" {...props}>
            <path
                d="M11 1L14.09 7.26L21 8.27L16 13.14L17.18 20.02L11 16.77L4.82 20.02L6 13.14L1 8.27L7.91 7.26L11 1Z"
                fill="currentColor"
                stroke="#333333"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

const Redirect = props => (
    <Icon viewBox="0 0 16 16" {...props}>
        <path
            d="M11.5359 4.46484L4.46484 11.5359"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
        />
        <path
            d="M5.87891 4.46484H11.5358V10.1217"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
        />
    </Icon>
)

const Refresh = props => {
    return (
        <Icon viewBox="0 0 16 16" {...props}>
            <path
                d="M13.6498 2.35C12.9097 1.60485 12.0294 1.01356 11.0597 0.610231C10.09 0.206901 9.05001 -0.000494355 7.99977 8.84845e-07C3.57977 8.84845e-07 0.00976562 3.58 0.00976562 8C0.00976562 12.42 3.57977 16 7.99977 16C11.7298 16 14.8398 13.45 15.7298 10H13.6498C13.2378 11.1695 12.4731 12.1824 11.4611 12.8988C10.4491 13.6153 9.23971 14 7.99977 14C4.68977 14 1.99977 11.31 1.99977 8C1.99977 4.69 4.68977 2 7.99977 2C9.65977 2 11.1398 2.69 12.2198 3.78L8.99977 7H15.9998V8.84845e-07L13.6498 2.35Z"
                fill="#333333"
            />
        </Icon>
    )
}

const Timer = () => {
    return (
        <Icon
            width="8"
            height="8"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.9663 12.3647C12.8634 11.8721 12.8096 11.3632 12.8096 10.8442V9.58594H24.0572V10.8448C24.0572 11.9152 23.8283 12.9424 23.4118 13.8736M23.4141 13.8736C23.8308 12.9427 24.0596 11.9152 24.0596 10.845V9.58594H18.4346M12.9733 23.6836C13.509 21.1958 15.2986 19.1271 17.7314 18.2592V17.8345C15.2868 16.9599 13.4923 14.8733 12.9689 12.3669M23.8913 23.6836C23.3565 21.1968 21.5687 19.1284 19.1377 18.2592V17.8365C20.4871 17.3542 21.6386 16.5031 22.4874 15.4157C22.8563 14.9432 23.168 14.4262 23.4141 13.8758M23.8913 23.6858C24 24.1916 24.0572 24.7152 24.0572 25.2491V26.5101M12.9755 23.6858C12.8668 24.1921 12.8096 24.7162 12.8096 25.2505V26.5101H24.0572M24.0572 26.5101L18.4346 26.5102"
                stroke="#787878"
                strokeWidth="0.6"
            />
            <path
                d="M12.8125 9.53906V10.7973C12.8125 11.3163 12.8663 11.8252 12.9692 12.3179L18.6277 14.8416L23.4147 13.8267C23.8312 12.8955 24.0602 11.8683 24.0602 10.7979V9.53906H12.8125Z"
                fill="#F5F9FB"
            />
            <path
                d="M24.0625 9.53906V10.7981C24.0625 11.8683 23.8338 12.8958 23.417 13.8267L18.6302 14.8416L18.4375 14.7558V9.53906H24.0625Z"
                fill="#EBF3F7"
            />
            <path
                d="M23.8923 23.6367C23.3071 20.9165 21.223 18.6969 18.4377 18L18.4328 18.0012C15.6472 18.6974 13.5624 20.9166 12.9766 23.6368L18.4354 24.1875L23.8923 23.6367Z"
                fill="#F5F9FB"
            />
            <path
                d="M23.8942 23.6367L18.4375 24.1875V18.0009L18.4398 18C21.2252 18.697 23.3092 20.9166 23.8942 23.6367Z"
                fill="#EBF3F7"
            />
            <path
                d="M11.4062 7.17188V10.2422H25.4641V7.17188H11.4062Z"
                fill="#6E5A8A"
            />
            <path
                d="M25.4664 7.17188V10.2422H18.4375V7.17188H25.4664Z"
                fill="#58486E"
            />
            <path
                d="M23.8942 23.6392H20.7812C20.1268 22.9848 19.6777 22.5356 19.1406 21.9986V17.7898C20.49 17.3075 21.6415 16.4565 22.4903 15.3691C22.8592 14.8966 23.1709 14.3795 23.417 13.8292C19.2606 13.7481 17.6425 12.4005 12.9719 12.3203C13.4952 14.8267 15.2897 16.9133 17.7344 17.7879V21.9986L16.0938 23.6392H12.9784C12.8697 24.1455 12.8125 24.6695 12.8125 25.2039V26.4634H24.0602V25.2025C24.0602 24.6686 24.003 24.145 23.8942 23.6392Z"
                fill="#F0B847"
            />
            <path
                d="M24.0602 25.2022V26.4631H18.4375V13.0859C19.9277 13.4389 21.362 13.7886 23.417 13.8289C23.1709 14.3792 22.8592 14.8963 22.4903 15.3688C21.6414 16.4563 20.4902 17.307 19.1406 17.7894V21.9983L20.7812 23.6389H23.8942C24.003 24.1447 24.0602 24.6683 24.0602 25.2022Z"
                fill="#F3C66C"
            />
            <path
                d="M11.4062 25.7812V28.8516H25.4641V25.7812H11.4062Z"
                fill="#6E5A8A"
            />
            <path
                d="M25.4664 25.7812V28.8516H18.4375V25.7812H25.4664Z"
                fill="#58486E"
            />
            <path
                d="M10 28.5938V30H26.8728C26.8728 30 26.8703 29.6852 26.8703 29.2969C26.8703 28.9086 26.8703 28.5938 26.8703 28.5938H10Z"
                fill="#58486E"
            />
            <path
                d="M26.875 29.2969V30H18.4375V28.5938H26.875V29.2969Z"
                fill="#4D3F61"
            />
            <path
                d="M10 6V7.40625H26.8728C26.8728 7.40625 26.8703 7.09144 26.8703 6.70312C26.8703 6.31481 26.8703 6 26.8703 6H10Z"
                fill="#58486E"
            />
            <path
                d="M26.875 6.70312V7.40625H18.4375V6H26.875V6.70312Z"
                fill="#4D3F61"
            />
        </Icon>
    )
}

const KalviumLogo = props => (
    <Icon viewBox="0 0 155 32" fill="none" {...props}>
        <g clipPath="url(#clip0_157849_6355)">
            <path
                d="M0 0V31.9862H27.1314V0H0ZM3.5145 28.6184V17.709L23.6178 28.6184H3.5145ZM23.6178 24.6339L7.10795 15.9611L23.6178 7.39978V24.6331V24.6339ZM3.5145 14.2798V3.42659H23.6178L3.5145 14.2798Z"
                fill="#EF3837"
            />
            <path
                d="M49.8959 28.6189L43.1801 18.1965L40.0967 21.6127V28.6189H34.5801V3.80078H40.0967V14.8512L49.5535 3.80078H55.9607L46.7779 14.0494L56.3031 28.6198H49.8959V28.6189Z"
                fill="#EF3837"
            />
            <path
                d="M56.5078 23.5295C56.5078 20.7411 58.0841 18.4752 62.6063 18.0921L66.3754 17.7781C67.8488 17.6389 68.2595 17.1857 68.2595 16.4186C68.2595 14.8851 67.3343 14.0134 65.5531 14.0134C63.7719 14.0134 62.8467 14.8151 62.6746 16.4186H57.4667C57.4667 12.6884 59.797 10.2832 65.4848 10.2832C71.1726 10.2832 73.5029 12.6884 73.5029 16.4186V24.0173C73.5029 26.457 73.7086 28.0259 74.0511 28.6183H69.2885C68.8086 27.9913 68.5345 27.2934 68.5345 26.1085C67.541 27.9904 65.8964 28.9669 62.9496 28.9669C58.7352 28.9669 56.5078 26.841 56.5078 23.5286V23.5295ZM68.2604 21.3682V20.3571C68.0209 20.6356 67.3352 20.8103 66.3763 20.915L64.4576 21.0542C62.5043 21.2289 61.7512 22.0307 61.7512 23.1455C61.7512 24.505 62.5735 25.4114 64.4922 25.4114C66.8908 25.4114 68.2613 23.5641 68.2613 21.3682H68.2604Z"
                fill="#EF3837"
            />
            <path
                d="M76.1055 28.6189V3.80078H81.348V28.6189H76.1055Z"
                fill="#EF3837"
            />
            <path
                d="M88.9209 28.6175L82.582 10.6309H88.0303L92.1072 24.0164L96.185 10.6309H101.633L95.2944 28.6175H88.9218H88.9209Z"
                fill="#EF3837"
            />
            <path
                d="M102.523 5.68172C102.523 4.14832 103.585 2.99805 105.47 2.99805C107.355 2.99805 108.451 4.14832 108.451 5.68172C108.451 7.21513 107.389 8.3654 105.47 8.3654C103.552 8.3654 102.523 7.21513 102.523 5.68172ZM102.866 28.6179V10.6313H108.108V28.6179H102.866Z"
                fill="#EF3837"
            />
            <path
                d="M110.711 22.5176V10.6309H115.953V21.4719C115.953 23.5632 116.707 24.6789 118.489 24.6789C120.476 24.6789 121.778 23.2501 121.778 20.6702V10.6309H127.02V28.6175H122.052V25.8983C121.127 27.641 119.62 28.966 116.809 28.966C112.766 28.966 110.711 26.8748 110.711 22.5176Z"
                fill="#EF3837"
            />
            <path
                d="M149.703 28.6183V17.638C149.703 15.5113 148.983 14.5703 147.578 14.5703C146.002 14.5703 144.666 15.8599 144.666 18.4043V28.6175H139.664V17.6371C139.664 15.5104 138.91 14.5695 137.539 14.5695C135.929 14.5695 134.627 15.859 134.627 18.4034V28.6166H129.625V10.6317H134.593V13.3509C135.484 11.6082 136.854 10.2832 139.253 10.2832C141.788 10.2832 143.433 11.2942 144.221 13.4201C145.112 11.5727 146.791 10.2832 149.19 10.2832C152.856 10.2832 154.74 12.3744 154.74 16.7316V28.6183H149.703H149.703Z"
                fill="#EF3837"
            />
        </g>
        <defs>
            <clipPath id="clip0_157849_6355">
                <rect width="154.791" height="32" fill="white" />
            </clipPath>
        </defs>
    </Icon>
)

export {
    ArrowForward,
    Assets,
    BackToTopIcon,
    CaretDown,
    CaretLeft,
    CaretRight,
    CaretUp,
    Caution,
    Credits,
    Cross,
    CrossLight,
    DrawerActive,
    DrawerInactive,
    Duration,
    EnterArrow,
    Feedback,
    GChat,
    GMail,
    Home,
    Idea,
    Info,
    IntegrityChecked,
    KalviumLogo,
    LearningUnits,
    Livebooks,
    LogOut,
    LogOut24,
    MaDTick,
    MaDTickSquare,
    Modules,
    NextArrow,
    Playground,
    PreviousArrow,
    Profile,
    QnA,
    Redirect,
    Refresh,
    Search,
    SearchBold,
    Star,
    Target,
    Tick,
    Tick2,
    Timer,
    Tools,
    Triangle,
    Warning,
    Zap,
}
